import { message } from 'antd';
import _ from 'lodash';
import Request from 'common/network/Request';
import { logout as logoutAction } from 'store/reducers/auth/slice';
import userEndpoint from 'modules/auth/api';
import { store } from 'store/store';
import routes from 'routes/constants/routes';

export const logout = async () => {
  try {
    await Request.post(userEndpoint.logout);
    store.dispatch(logoutAction());
    message.success('Đăng xuất thành công!');
    window.location.href = routes.login;
  } catch (error) {
    console.error(error);
  }
};

export const getMainRouteIfLoggedIn = () => {
  const info = _.get(store.getState(), 'auth.info');

  return routes.dashboard;
  // return info?.password_changed ? routes.dashboard : routes.changePassword;
};
